import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'

const CentersActions = importer('Stores/Centers/Actions')
const { saveCenterSlotConfig, saveMassUpdateConfig } = importer('APIs/centers', null)
const { tokens } = importer('Stores/Users/Select', null)

export default function * main ({ isMassUpdate, date, center, slotsArray, startDate, endDate, weekDays, appointmentType }) {
  try {
    yield put(CentersActions.saveCenterSlotConfigLoading())
    let res = null
    const _tokens = yield select(tokens)
    if (_tokens) {
      const { token_type, id_token } = _tokens
      const token = `${token_type} ${id_token}`
      res = isMassUpdate ? 
        yield saveMassUpdateConfig(date, center, slotsArray, startDate, endDate, weekDays,appointmentType, token) :
        yield saveCenterSlotConfig(date, center, slotsArray, token)
    } else {
      res = yield saveCenterSlotConfig(date, center, slotsArray)
    }
    yield put(CentersActions.saveCenterSlotConfigSuccess(res))
  } catch (error) {
    yield put(CentersActions.saveCenterSlotConfigFailure(error))
  }
}
